<template>
    <div class="panel panel-flat">
        <div class="panel-heading">
            <h4><i class="fa fa-home"></i> {{transEdit('welcome')}} {{part.username}}!</h4>
        </div>
        <div class="panel-body">

        </div>
    </div>
</template>

<script>
    export default {
        props: ['part'],
        name: "admin-dash-intro"
    }
</script>

<style scoped>

</style>